import { createContext } from "react";

const DepartamentosContext = createContext();

export default DepartamentosContext;
